import router , { constantRoutes, ayscRoutes } from "./router"
import NProgress from 'nprogress' // progress bar
import { setMenus, getToken, getRoles, getUserInfo, logout } from './utils/auth'
import { filterAsyncRoutes } from './utils/app'
import store from "./store"
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({ showSpinner: false });// NProgress Configuration

const whiteList = ['/login','/404','/401', '/merchants/form', '/merchants/unlimit/form'];

router.beforeEach(async (to, from, next) => {
  if(!whiteList.includes(to.path)){
    NProgress.start()
  }
  const hasToken = getToken()? getToken()!=='' : false
  const hasRoles = getRoles() ? getRoles().length > 0 : false
  
  if(hasToken){
    if(to.path === '/login'){
      next('/')
      return 
    }
    if(hasRoles){
      // 拿到用户权限以后就过滤可用的路由
      let accessRoutes = await filterAsyncRoutes(ayscRoutes, getRoles())
      setMenus([...constantRoutes,...accessRoutes])
      // 判断用户是否有权限进入该路由
      let isPermissionaAllow =  true
      if(to.meta.roles){
        isPermissionaAllow = getRoles().some(role => to.meta.roles.includes(role))
        if(isPermissionaAllow){
          next()
        }else{
          next('/404')
        }
      }else{
        next()
      }
    }else{
      // 没有权限的时候先尝试获取，如果也获取失败就跳转登录
      let { code } = await getUserInfo(getToken())
      if(code === 200){
        next({...to,replace:true})
      }else{
        logout()
        next({
          path:'/login'
        })
      }
    }
  }else{
    if(whiteList.includes(to.path)){
      next()
    }else{
      next({
        path:'/login'
      })
    }
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})